import React from 'react';
import './Footer.css';
import { data, images } from '../../constants';
import { FiArrowUpRight, FiMail } from 'react-icons/fi'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <a href="#home" className="brand-lockup footer-lockup" aria-label="SmartSastram home">
              <img src={images.logo} alt="SmartSastram" className="brand-logo footer-brand-logo" />
            </a>
            <p>Enterprise AI initiatives across data, applied intelligence, voice systems, and physical-world automation.</p>
          </div>

          <div className="footer-column">
            <h3>Navigate</h3>
            <ul className="navbar-footer">
              {data.Menu.map((item, index) => (
                <li key={index}><a href={item.link}>{item.text}</a></li>
              ))}
              <li><a href="#use-cases">Use cases</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Product</h3>
            <ul className="navbar-footer">
              <li><a href="#dataface">Dataface.ai</a></li>
              <li><a href="https://dataface.ai" target="_blank" rel="noreferrer">Visit product site <FiArrowUpRight /></a></li>
              <li><a href="#capabilities">AI product engineering</a></li>
              <li><a href="#approach">Governed AI delivery</a></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h3>Contact</h3>
            <a href="mailto:contact@smartsastram.com"><FiMail /> contact@smartsastram.com</a>
            <p>Hyderabad, India</p>
          </div>
        </div>

        <div className="rights">
          <p>© {new Date().getFullYear()} SmartSastram Private Limited. All rights reserved.</p>
          <p>Data + AI, voice AI, and physical AI initiatives.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
